// hooks/useAtualizarDados.ts
import { useState } from "react";
// --------------------- Import Services ---------------------
import { atualizarApartamento } from "../services/atualizarApartamentoService";
import { atualizarEmpreendimento } from "../services/atualizarEmpreendimentoService";
import { atualizarCotaUsuario } from "../services/atualizarCotaUsuarioService";
// --------------------- Import Interface ---------------------
import { Apartamento } from "../interfaces/Apartamento";
import { Empreendimento } from "../interfaces/Empreendimento";
import { CotaUsuario } from "../interfaces/CotaUsuario";

export const useAtualizarDados = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const atualizarDados = async (
    aptoId: number | undefined,
    valuesAp: Apartamento,
    empreendId: number | undefined,
    valuesEmp: Empreendimento,
    cotaUsuarioId: number | undefined | null,
    valuesMaisInfo: CotaUsuario
  ) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    try {
      const atualizarApto = await atualizarApartamento(aptoId, valuesAp);
      const atualizarEmp = await atualizarEmpreendimento(empreendId, valuesEmp);
      const atualizarCTU = await atualizarCotaUsuario(
        cotaUsuarioId,
        valuesMaisInfo
      );

      if (atualizarApto && atualizarEmp && atualizarCTU) {
        setSuccess("Os dados foram atualizados!");
      } else {
        setError("Não foi possível atualizar os dados!");
      }
     
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return { atualizarDados, isLoading, isSuccess, error, success };
};
